// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rules__wrapper__2hi32","textRules":"rules__textRules__1ghnM","title":"rules__title__3iBHi","rulesText":"rules__rulesText__3KOHf"};